import axios from 'axios';
import { RecuringJobLogRequest, RecuringJobLog } from '../schemas/RecuringJobLog.schema';

export function retrieveRecuringJobLog(params: RecuringJobLogRequest) {
    return axios.get<RecuringJobLog[]>('/v1/log/recuring-job', {
        params,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('WF_APPLICATION')
        }
    });
}
